export const PARKING_BASE_PATH = `/vehicles-illegally-parked`;
export const RoutesList = {
  PARKING_HOME: PARKING_BASE_PATH,
  ISSUE_TYPE: PARKING_BASE_PATH + '/issue-type',
  VEHICLE_DETAILS: PARKING_BASE_PATH + '/vehicle-details',
  UPLOAD_PHOTO: PARKING_BASE_PATH + '/upload-photo',
  ISSUE_LOCATION: PARKING_BASE_PATH + '/issue-location',
  DATETIME_DETAILS: PARKING_BASE_PATH + '/datetime-details',
  EMAIL_CONFIRMATION_REPORT: PARKING_BASE_PATH + '/email-confirmation-report',
  REPORT_TO_TFL: PARKING_BASE_PATH + '/report-to-tfl',
  YOUR_DETAILS: PARKING_BASE_PATH + '/your-details',
  CONFIRMATION: PARKING_BASE_PATH + '/confirmation',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Details',
    urlPaths: [RoutesList.ISSUE_TYPE, RoutesList.VEHICLE_DETAILS],
  },
  {
    label: 'Photos',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Location',
    urlPaths: [RoutesList.ISSUE_LOCATION, RoutesList.REPORT_TO_TFL],
  },
  {
    label: 'Date and time',
    urlPaths: [RoutesList.DATETIME_DETAILS],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.EMAIL_CONFIRMATION_REPORT, RoutesList.YOUR_DETAILS],
  },
];
